/**!
 * Created by Leonardo Cheslacki on 08/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StudentController from './StudentController';

import WithType from './../helpers/WithType';

import config from '../../../../config';

const {default: {routes: {api, web}}} = config;

let _this = {};

/**
 *
 */
class StudentDashboard extends StudentController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {}
        };

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handleShowBridge: function (event) {
            const
                {bridges} = _this.props,
                _this_frame = _this.getFrame(),
                {occ_bridge_library, occ_bridge_game, occ_bridge_notification} = _this_frame;

            let
                {name} = event.target,
                occ = `occ_bridge_${name.replace('btn_', '')}`;

            if (_this.inObject(_this_frame, occ)) {
                _this_frame[occ].visible = true;
                _this.effectFadeIn(_this_frame, occ);
            } else {
                occ_bridge_library.visible = occ_bridge_game.visible = occ_bridge_notification.visible = true;
                _this.effectFadeIn(_this_frame, bridges);
            }
        },
        /**
         *
         * @param event
         */
        handleHideBridge: function (event) {
            const
                {bridges} = _this.props,
                _this_frame = _this.getFrame(),
                {occ_bridge_library, occ_bridge_game, occ_bridge_notification} = _this_frame;

            let
                {name} = event.target,
                occ = `occ_bridge_${name.replace('btn_', '')}`;

            if (_this.inObject(_this_frame, occ)) {
                _this.effectFadeOut(_this_frame, occ, () => {
                    _this_frame[occ].visible = false;
                });
            } else {
                _this.effectFadeOut(_this_frame, bridges, () => {
                    occ_bridge_library.visible = occ_bridge_game.visible = occ_bridge_notification.visible = false;
                });
            }
        }
    };

    addStatus = () => {
        const
            {data} = this.state,
            {occ_status, btn_notification: {occ_unvisited, occ_hover, occ_active}} = this.getFrame(),
            {occ_name, occ_experience} = occ_status,
            formatted_name = _this.verifyField(data, 'profile.formatted_name'),
            year = _this.verifyField(data, 'classroom_student.year.year');

        this.addAvatar(occ_status);

        occ_name.text = formatted_name;
        occ_experience.text = year;

        let upper = `BEM-VINDA, ${formatted_name}!`;
        occ_unvisited.occ_logo.occ_text.text = upper;
        occ_hover.occ_animate.occ_logo.occ_text.text = upper;
        occ_active.occ_animate.occ_logo.occ_text.text = upper;
    };

    startDashboard = () => {
        const
            {button_menu_dashboard} = this.props,
            {btn_school, btn_library, btn_game, btn_notification} = this.getFrame();

        this.addStatus();

        this.setActions(button_menu_dashboard);

        this._handleHideBridgeScholl && btn_school.off('mouseover', this._handleHideBridgeScholl);
        this._handleHideBridgeScholl = btn_school.on('mouseover', this.$functions.handleHideBridge);

        this._handleShowBridgeScholl && btn_school.off('mouseout', this._handleShowBridgeScholl);
        this._handleShowBridgeScholl = btn_school.on('mouseout', this.$functions.handleShowBridge);

        this._handleHideBridgeLibrary && btn_library.off('mouseover', this._handleHideBridgeLibrary);
        this._handleHideBridgeLibrary = btn_library.on('mouseover', this.$functions.handleHideBridge);

        this._handleShowBridgeLibrary && btn_library.off('mouseout', this._handleShowBridgeLibrary);
        this._handleShowBridgeLibrary = btn_library.on('mouseout', this.$functions.handleShowBridge);

        this._handleHideBridgeGame && btn_game.off('mouseover', this._handleHideBridgeGame);
        this._handleHideBridgeGame = btn_game.on('mouseover', this.$functions.handleHideBridge);

        this._handleShowBridgeGame && btn_game.off('mouseout', this._handleShowBridgeGame);
        this._handleShowBridgeGame = btn_game.on('mouseout', this.$functions.handleShowBridge);

        this._handleHideBridgeNotification && btn_notification.off('mouseover', this._handleHideBridgeNotification);
        this._handleHideBridgeNotification = btn_notification.on('mouseover', this.$functions.handleHideBridge);

        this._handleShowBridgeNotification && btn_notification.off('mouseout', this._handleShowBridgeNotification);
        this._handleShowBridgeNotification = btn_notification.on('mouseout', this.$functions.handleShowBridge);
    };

    initDashboard = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_profile}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startDashboard);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StudentDashboard.propTypes = {
    current_name: PropTypes.string,
    button_menu_dashboard: PropTypes.array,
    bridges: PropTypes.array
};

/**
 *
 * @type {{}}
 */
StudentDashboard.defaultProps = {
    current_name: null,
    button_menu_dashboard: [
        {
            occ: 'profile',
            uri: web.uri_profile
        },
        {
            occ: 'library',
            uri: web.uri_library
        },
        {
            occ: 'game',
            uri: web.uri_game
        },
        {
            occ: 'game',
            uri: web.uri_game
        },
        {
            occ: 'school',
            uri: web.uri_school_files
        }
    ],
    bridges: ['occ_bridge_library', 'occ_bridge_game', 'occ_bridge_notification']
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StudentDashboard, {className: 'StudentDashboard'});
